import { isEmpty } from "lodash";
import logger from "@clearquote/common/logger";
import { environment } from "@cq/environments/environment";

// Converted from js script provided to us
export function initGoogleTagManager(url: string) {
  if (!environment.isGoogleTagManagerEnabled || isEmpty(url)) {
    logger.warn(
      "Google Tag Manager integration disabled, or not configured. Bypassing initialization.",
    );
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    "gtm.start": new Date().getTime(),
    event: "gtm.js",
  });

  const gtm = document.createElement("script");
  gtm.async = true;
  gtm.src = url;

  const s = document.getElementsByTagName("script")[0];
  s.parentNode?.insertBefore(gtm, s);
}
